import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { tmaisFaqsColumns } from '@/features/tmaisFaqs/constants/columns.constant'
import { useTmaisFaqs } from '@/features/tmaisFaqs/hooks/useTmaisFaqs'
import { TmaisFaqsTransformer } from '@/features/tmaisFaqs/services/tmaisFaqsTransformer'
import { TmaisFaqData, TmaisFaqTableItem } from '@/features/tmaisFaqs/types/tmaisFaq.type'
import { MessageCircleQuestionIcon } from 'lucide-react'

const TmaisFaqsList = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: faqs = [],
    meta,
    isLoading: faqsIsLoading,
    error: faqsError = {} as any,
    refetch: refetchFaqs,
  } = useTmaisFaqs<TmaisFaqTableItem[]>({
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<TmaisFaqData[], TmaisFaqTableItem[]>({
      transformer: TmaisFaqsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="inner-screen gap-6">
      <ListHeader
        Icon={<MessageCircleQuestionIcon className="size-10" strokeWidth={1.5} />}
        title="FAQs"
        createButtonText="Novo FAQ"
        operationKlassToCheckPermission="Admin::Tmais::Faqs::Create"
        disableCreateButton={faqsIsLoading || faqsError?.status === 403}
      />

      <ErrorMessageWrapper className="flex-1" statusCode={faqsError?.status} refetchFunction={refetchFaqs}>
        <div className="flex-1 flex flex-col gap-6">
          <Table
            columns={tmaisFaqsColumns}
            isLoadingData={faqsIsLoading}
            rows={faqs || []}
            page={filterParams.page || 1}
            totalPages={meta?.total_pages}
            totalCount={meta?.total}
            hasPagination
            setPage={(page) => setFilterParams((prev: any) => ({ ...prev, page }))}
            rowEmptyValue="--"
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default TmaisFaqsList
